import React from 'react'
import styled from '@emotion/styled'
import {
  Section,
  SectionHeader,
  Title
} from 'components/Locations/AvailabilityRules/commonStyles'
import { OptionWrapper } from 'components/Common'
import { PrimaryButton, OutlineButton } from './styles'
import { SHIPDAY_SIGNUP_URL } from '../../constants'

interface EntryPageProps {
  onContinue: () => void
}

const EntryPage = ({ onContinue }: EntryPageProps) => {
  const handleCreateAccount = () => {
    window.open(SHIPDAY_SIGNUP_URL, '_blank', 'noopener,noreferrer')
    onContinue()
  }

  return (
    <PageRoot>
      <Section>
        <SectionHeader>
          <Title>
            <strong>Welcome to Shipday Integration</strong>
            <span>Get started by connecting your Shipday account</span>
          </Title>
        </SectionHeader>

        <OptionWrapper columns={2}>
          <OptionCard>
            <OptionTitle>ALREADY HAVE A SHIPDAY ACCOUNT?</OptionTitle>
            <OptionDescription>
              Sign in to your existing Shipday account, then return here to
              connect it with your stores
            </OptionDescription>
            <Actions>
              <PrimaryButton
                style={{ width: 'min-content' }}
                onClick={onContinue}
              >
                CONTINUE WITH EXISTING ACCOUNT
              </PrimaryButton>
            </Actions>
          </OptionCard>

          <OptionCard>
            <OptionTitle>NEW TO SHIPDAY?</OptionTitle>
            <OptionDescription>
              Create your Shipday account first, then come back to this page to
              set up the integration
            </OptionDescription>
            <Actions>
              <OutlineButton
                style={{ width: 'min-content' }}
                onClick={handleCreateAccount}
              >
                CREATE SHIPDAY ACCOUNT
              </OutlineButton>
            </Actions>
          </OptionCard>
        </OptionWrapper>
      </Section>
    </PageRoot>
  )
}

const PageRoot = styled.div`
  margin: 0 auto;
`

const Actions = styled.div`
  padding-top: 8px;
  display: flex;
  justify-content: center;
`

const OptionCard = styled.div`
  padding: 12px 8px;
  background-color: #fafafb;
  border: 1px solid #d2d2d9;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: center;
`

const OptionTitle = styled.strong`
  font-size: 14px;
  font-weight: 600;
  color: #4a4a68;
  letter-spacing: 0.04em;
  text-transform: uppercase;
`

const OptionDescription = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: #77778e;
  line-height: 1.5;
  flex: 1;
`

export default EntryPage
